import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import TrackVisibility from 'react-on-screen';
import 'animate.css';
import contactImg from '../assets/img/contact-img.svg';

const emptyForm = { firstName: '', lastName: '', email: '', phone: '', message: '' };

export const Contact = () => {
  const [formDetails, setFormDetails] = useState(emptyForm);
  const [buttonText, setButtonText] = useState('Send');
  const [status, setStatus] = useState(null);
  const endpoint = import.meta.env.VITE_CONTACT_ENDPOINT;

  const updateField = (field, value) => {
    setFormDetails((current) => ({ ...current, [field]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus(null);

    if (!endpoint) {
      setStatus({ success: false, message: 'The contact form needs a VITE_CONTACT_ENDPOINT value before it can send messages.' });
      return;
    }

    setButtonText('Sending...');
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json;charset=utf-8' },
        body: JSON.stringify(formDetails),
      });

      if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
      setFormDetails(emptyForm);
      setStatus({ success: true, message: 'Message sent successfully.' });
    } catch (error) {
      console.error(error);
      setStatus({ success: false, message: 'Something went wrong. Please try again later.' });
    } finally {
      setButtonText('Send');
    }
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => <img className={isVisible ? 'animate__animated animate__zoomIn' : ''} src={contactImg} alt="Contact" />}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? 'animate__animated animate__fadeIn' : ''}>
                  <h2>Get In Touch</h2>
                  <form onSubmit={handleSubmit}>
                    <Row>
                      <Col xs={12} sm={6} className="px-1">
                        <input required type="text" value={formDetails.firstName} placeholder="First Name" onChange={(e) => updateField('firstName', e.target.value)} />
                      </Col>
                      <Col xs={12} sm={6} className="px-1">
                        <input required type="text" value={formDetails.lastName} placeholder="Last Name" onChange={(e) => updateField('lastName', e.target.value)} />
                      </Col>
                      <Col xs={12} sm={6} className="px-1">
                        <input required type="email" value={formDetails.email} placeholder="Email Address" onChange={(e) => updateField('email', e.target.value)} />
                      </Col>
                      <Col xs={12} sm={6} className="px-1">
                        <input type="tel" value={formDetails.phone} placeholder="Phone No." onChange={(e) => updateField('phone', e.target.value)} />
                      </Col>
                      <Col xs={12} className="px-1">
                        <textarea required rows="6" value={formDetails.message} placeholder="Message" onChange={(e) => updateField('message', e.target.value)} />
                        <button type="submit"><span>{buttonText}</span></button>
                      </Col>
                      {status?.message && (
                        <Col xs={12}>
                          <p className={status.success ? 'success' : 'danger'}>{status.message}</p>
                        </Col>
                      )}
                    </Row>
                  </form>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
